import {ReactStateDeclaration, Transition} from '@uirouter/react';
import {Page} from '../../views/Page';
import {CatalogPage} from '../../views/Catalog';

interface RoutingConfig {}

export const InitRouting = (config: RoutingConfig): ReactStateDeclaration[] => {
  return [
    {
      abstract: true,
      name: 'page',
      component: Page,
      url: '',
    },
    {
      parent: 'page',
      name: 'home',
      url: '/',
      redirectTo: {
        state: 'catalog',
        params: {
          id: 123
        }
      },
    },
    {
      parent: 'page',
      name: 'catalog',
      component: CatalogPage,
      url: '/catalog/:id',
      resolve: [
        {
          token: 'id',
          deps: ['$transition$'],
          resolveFn: (trans: Transition) => {
            return trans.params().id;
          },
        },
      ],
    },
  ];
};
